/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataReactionAction } from '../models/data-reaction-action';
import { ExecuteSystemButtonDto } from '../models/execute-system-button-dto';
import { GetSystemButtonsStatusForEntriesRequestDtoModel } from '../models/get-system-buttons-status-for-entries-request-dto-model';
import { SystemButtonDataEntryDto } from '../models/system-button-data-entry-dto';
import { SystemButtonOptionsDto } from '../models/system-button-options-dto';
import { SystemButtonStatusForEntriesResponseDtoModel } from '../models/system-button-status-for-entries-response-dto-model';

@Injectable({ providedIn: 'root' })
export class SystemButtonControllerService extends DataBaseService {

  /**
   * Path part for operation systemButtonControllerFindForUser
   */
  static readonly SystemButtonControllerFindForUserPath = '/v1/system-buttons/{relatedToId}/active';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findForUser()` instead.
   *
   * This method doesn't expect any request body.
   */
  findForUser$Response(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<SystemButtonDataEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerFindForUserPath, 'get');
    if (params) {
      rb.path('relatedToId', params.relatedToId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SystemButtonDataEntryDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findForUser$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findForUser(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<SystemButtonDataEntryDto>> {

    return this.findForUser$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SystemButtonDataEntryDto>>) => r.body as Array<SystemButtonDataEntryDto>)
    );
  }

  /**
   * Path part for operation systemButtonControllerGetSystemButtonActionWithOptions
   */
  static readonly SystemButtonControllerGetSystemButtonActionWithOptionsPath = '/v1/system-buttons/{id}/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemButtonActionWithOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemButtonActionWithOptions$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<DataReactionAction>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerGetSystemButtonActionWithOptionsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DataReactionAction>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSystemButtonActionWithOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemButtonActionWithOptions(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<DataReactionAction>> {

    return this.getSystemButtonActionWithOptions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DataReactionAction>>) => r.body as Array<DataReactionAction>)
    );
  }

  /**
   * Path part for operation systemButtonControllerGetSystemButtonsStatusForEntries
   */
  static readonly SystemButtonControllerGetSystemButtonsStatusForEntriesPath = '/v1/system-buttons/{relatedToId}/status/entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemButtonsStatusForEntries()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSystemButtonsStatusForEntries$Response(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: GetSystemButtonsStatusForEntriesRequestDtoModel
  }): Observable<StrictHttpResponse<Array<SystemButtonStatusForEntriesResponseDtoModel>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerGetSystemButtonsStatusForEntriesPath, 'post');
    if (params) {
      rb.path('relatedToId', params.relatedToId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SystemButtonStatusForEntriesResponseDtoModel>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSystemButtonsStatusForEntries$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getSystemButtonsStatusForEntries(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: GetSystemButtonsStatusForEntriesRequestDtoModel
  }): Observable<Array<SystemButtonStatusForEntriesResponseDtoModel>> {

    return this.getSystemButtonsStatusForEntries$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SystemButtonStatusForEntriesResponseDtoModel>>) => r.body as Array<SystemButtonStatusForEntriesResponseDtoModel>)
    );
  }

  /**
   * Path part for operation systemButtonControllerExecuteSystemButton
   */
  static readonly SystemButtonControllerExecuteSystemButtonPath = '/v1/system-buttons/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeSystemButton()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeSystemButton$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExecuteSystemButtonDto
  }): Observable<StrictHttpResponse<string>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerExecuteSystemButtonPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `executeSystemButton$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  executeSystemButton(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: ExecuteSystemButtonDto
  }): Observable<string> {

    return this.executeSystemButton$Response(params).pipe(
      map((r: StrictHttpResponse<string>) => r.body as string)
    );
  }

  /**
   * Path part for operation systemButtonControllerFind
   */
  static readonly SystemButtonControllerFindPath = '/v1/system-buttons/{relatedToId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<SystemButtonDataEntryDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerFindPath, 'get');
    if (params) {
      rb.path('relatedToId', params.relatedToId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SystemButtonDataEntryDto>>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params: {
    relatedToId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<SystemButtonDataEntryDto>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SystemButtonDataEntryDto>>) => r.body as Array<SystemButtonDataEntryDto>)
    );
  }

  /**
   * Path part for operation systemButtonControllerGetSystemButtonActionWithOptionsV2
   */
  static readonly SystemButtonControllerGetSystemButtonActionWithOptionsV2Path = '/v2/system-buttons/{id}/options';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSystemButtonActionWithOptionsV2()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemButtonActionWithOptionsV2$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<SystemButtonOptionsDto>> {

    const rb = new RequestBuilder(this.rootUrl, SystemButtonControllerService.SystemButtonControllerGetSystemButtonActionWithOptionsV2Path, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SystemButtonOptionsDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSystemButtonActionWithOptionsV2$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSystemButtonActionWithOptionsV2(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<SystemButtonOptionsDto> {

    return this.getSystemButtonActionWithOptionsV2$Response(params).pipe(
      map((r: StrictHttpResponse<SystemButtonOptionsDto>) => r.body as SystemButtonOptionsDto)
    );
  }

}
